import type { LaunchDarklyContext, LaunchDarklyCustomer } from '../launch-darkly.types';

/**
 * Creates a context with the user data.
 *
 * @see {@link https://docs.launchdarkly.com/sdk/features/user-context-config#configuring-context-objects User and context configuration}
 */
export function generateUserContext(params: Params): LaunchDarklyContext {
  const { customer } = params;

  const key = customer.id;

  const { firstName, lastName, email } = customer;

  return {
    key,
    firstName,
    lastName,
    email,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  customer: LaunchDarklyCustomer;
};
